// extracted by mini-css-extract-plugin
export default {"content-wrapper":"BrokerUserRegister_content-wrapper__pByYt","content":"BrokerUserRegister_content__YAwUU","no-img":"BrokerUserRegister_no-img__y3ptd"};